import { Link } from "react-router-dom";
import { getLatestVideos } from "@/utils/video";
import { VIDEO_TYPE_LABEL } from "@/types/video";

export default function NewArrivals() {
  const list = getLatestVideos(6);
  const featured = list[0];
  const rest = list.slice(1);

  if (!featured) return null;

  return (
    <section className="mx-auto w-full px-4 py-6 md:px-6 md:py-8 lg:px-10">
      <div className="overflow-hidden rounded-xl border border-background-800 bg-background-900">
        <div className="flex flex-col gap-3 border-b border-background-800 px-5 py-4 md:flex-row md:items-center md:justify-between md:px-7">
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-950">
              <i className="ri-fire-line text-lg"></i>
            </span>
            <div>
              <h2 className="text-lg font-bold text-foreground-50 md:text-xl">新片速递</h2>
              <p className="text-xs text-foreground-500">近期上线 · 第一时间追新</p>
            </div>
          </div>
          <Link
            to="/category/movie"
            className="group flex items-center gap-1 whitespace-nowrap text-sm text-foreground-400 transition-colors hover:text-primary-400"
          >
            全部新片
            <i className="ri-arrow-right-s-line transition-transform group-hover:translate-x-0.5"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-5 p-5 md:p-7 lg:grid-cols-[1.1fr_1.4fr]">
          <Link
            to={`/detail/${featured.id}`}
            className="group relative block overflow-hidden rounded-lg border border-background-800"
          >
            <div className="relative w-full aspect-video md:aspect-[16/10]">
              <img
                src={featured.poster}
                alt={featured.title}
                title={`${featured.title} - 新片速递`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/40 to-transparent"></div>
            </div>
            <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
              <span className="inline-block rounded bg-primary-500 px-2 py-0.5 text-[11px] font-medium text-background-950">
                {featured.status}
              </span>
              <h3 className="mt-2 text-lg font-bold text-foreground-50 md:text-xl">{featured.title}</h3>
              <p className="clamp-2 mt-1 text-xs text-foreground-300 md:text-sm">{featured.summary}</p>
            </div>
          </Link>

          <div className="flex flex-col divide-y divide-background-800">
            {rest.map((video, i) => (
              <Link
                key={video.id}
                to={`/detail/${video.id}`}
                className="group flex items-center gap-4 py-3 first:pt-0 last:pb-0"
              >
                <span className="font-heading w-6 flex-shrink-0 text-center text-lg font-semibold text-background-500 transition-colors group-hover:text-primary-500">
                  {i + 2}
                </span>
                <div className="h-16 w-24 flex-shrink-0 overflow-hidden rounded-md bg-background-800">
                  <img
                    src={video.poster}
                    alt={video.title}
                    title={`${video.title} - 新片速递`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="clamp-1 text-sm font-medium text-foreground-100 transition-colors group-hover:text-primary-400">
                    {video.title}
                  </h3>
                  <p className="mt-1 clamp-1 text-xs text-foreground-500">
                    {VIDEO_TYPE_LABEL[video.type]} · {video.year} · {video.genres.join("/")}
                  </p>
                  <div className="mt-1.5 flex items-center gap-2">
                    <span className="rounded bg-accent-100 px-1.5 py-0.5 text-[10px] font-medium text-accent-900">
                      {video.status}
                    </span>
                    <span className="flex items-center gap-0.5 text-xs text-accent-400">
                      <i className="ri-star-fill text-[10px]"></i>
                      {video.rating.toFixed(1)}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}